import { Link } from "react-router-dom";
import type { LucideIcon } from "lucide-react";

interface OverlayContentCardProps {
  title: string;
  description?: string;
  cta?: { text: string; href: string };
  variant?: "glass" | "solid";
  icon?: LucideIcon;
  className?: string;
  titleClassName?: string;
  descriptionClassName?: string;
  ctaClassName?: string;
}

const OverlayContentCard = ({
  title,
  description,
  cta,
  variant = "glass",
  icon: Icon,
  className = "",
  titleClassName = "",
  descriptionClassName = "",
  ctaClassName = "",
}: OverlayContentCardProps) => {
  const styles =
    variant === "glass"
      ? "bg-rich-black/72 backdrop-blur-md border border-cream/18 text-cream shadow-[0_18px_36px_-18px_rgba(0,0,0,0.45)]"
      : "bg-card border border-border text-foreground";

  const descColor = variant === "glass" ? "text-cream/82" : "text-muted-foreground";
  const ctaClass =
    variant === "glass"
      ? "font-body text-xs uppercase tracking-[0.14em] text-accent underline underline-offset-4 hover:text-accent/80 transition-colors"
      : "font-body text-xs uppercase tracking-[0.14em] text-accent hover:text-accent/80 transition-colors";

  return (
    <div className={`${styles} p-5 md:p-6 ${className}`}>
      {Icon && (
        <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-accent/14 border border-accent/20">
          <Icon className="w-4 h-4 text-accent" strokeWidth={1.8} aria-hidden="true" />
        </div>
      )}
      <h3 className={`font-headline text-lg md:text-xl mb-2 ${titleClassName}`}>{title}</h3>
      {description && (
        <p className={`${descColor} text-base leading-relaxed mb-3 ${descriptionClassName}`}>{description}</p>
      )}
      {cta && (
        <Link
          to={cta.href}
          className={`${ctaClass} ${ctaClassName}`}
        >
          {cta.text} →
        </Link>
      )}
    </div>
  );
};

export default OverlayContentCard;
